<div class="banner-top">
  <div class="banner-top-supergraphic"></div>
  <div class="header-content">
    <div class="portal-kv">
      <img src="https://ngportalqmaintenance.z6.web.core.windows.net/image/NG_Portal_Icon.svg" alt="portal key visual">
      <span>NG Portal</span>
    </div>
    <div class="bosch-logo">
      <img src="https://ngportalqmaintenance.z6.web.core.windows.net/image/Bosch-logo.svg" alt="Bosch logo">
    </div>
  </div>
</div>
<div class="content-wrapper flex md:flex-row justify-center w-full items-center gap-[66px] flex-col">
  <div class="flex flex-col items-center content-center w-[294px] gap-4">
    <h1 class="font-bold text-[80px] primary-blue pb-4 text-[var(--primary-blue)]">Oops!</h1>
    <div>
      <p class="text-center mb-2">
        It seems there was an issue with your session or you've been inactive for a while. Restarting the application will help you get back on track.
      </p>
      <p class="text-center mb-2">
        If the problem persists, feel free to contact our
        <a
          class="text-[var(--tag-color)] cursor-pointer"
          href="{{ NavigationSetup.SUPPORT.href }}"
          target="_blank"
          rel="noopener noreferrer"
        >
          Support
        </a>
      </p>
    </div>
    <app-button buttonLabel="Refresh" (click)="refresh()" [buttonType]="ButtonTypeEnum.PRIMARY" />
  </div>
  <img class="h-[200px] md:h-full" src="../../../../../assets/Error-page.svg" alt="error-page" />
</div>
